// import {mediaServicesAvailable} from '@netx/core-share-media-service/enablers/mediaServicesAvailable';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	categoryPermissionChecker,
	currentUserHasAccess,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next';
import {type ICategory} from '../schema';

// TODO: this is incomplete at the moment... more, it is a holdover for react until we get the share menu
// reworked one day
export const canShareCategory = (category?: ICategory) => {
	if (category == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	if (!currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS)) return false;
	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.DOWNLOAD,
	});
	// return (
	// 	(currentUserMeetsUserLevel(UserLevel.DIRECTOR) &&
	// 		mediaServicesAvailable()) ||
	// 	// share:assetSet:token -> matrix: 'download',
	// 	// share:assetSet:media:service -> [mediaServicesEnabled, downloadOptionSelected], matrix: 'download',
	// 	// share:token:embed -> [canEmbed], matrix: 'download',
	// 	(currentUserMeetsUserLevel(UserLevel.CONSUMER) &&
	// 		categoryPermissionChecker({
	// 			category,
	// 			permissionMatrixName: PermissionMatrixName.DOWNLOAD,
	// 			permissionName: PermissionName.DOWNLOAD,
	// 		}))
	// );
};

export default canShareCategory;
